import {
    SCHOOL_PROPERTY_TYPE,
    SCHOOL_PROPERTY_GROUP,
    HinhThucCanDoiThucDonList,
} from '@app/constants/schoolSetting.const';
import { MergedProperty, PropertyRenderConfig } from '../types';

/**
 * Pure function: map 1 property item → render config
 * Thay thế toàn bộ if/switch chain trong renderItemProperty cũ
 */
export function mapPropertyToRenderConfig(
    item: MergedProperty,
    kidGroupList: any[],
    proPackagingCache: any[],
    invoiceForm: any[],
): PropertyRenderConfig {
    let componentType: PropertyRenderConfig['componentType'] = 'textBox';
    let dataType = 'string';
    let colClass = 'col-md-3';
    let listSelect: any[] = [];
    let idField = '';
    let nameField = '';

    // --- Col class đặc biệt ---
    if (item.ps_code === 'dia_chi') colClass = 'col-md-9';
    if (item.ps_code === 'pgd_gan_nhat') colClass = 'col-md-12';

    // --- Data type theo p_datatype ---
    switch (item.p_datatype) {
        case SCHOOL_PROPERTY_TYPE.NUMBER:
            dataType = 'number';
            break;
        case SCHOOL_PROPERTY_TYPE.BOOLEAN:
            componentType = 'switch';
            dataType = 'boolean';
            break;
        case SCHOOL_PROPERTY_TYPE.DATE:
            dataType = 'date';
            break;
        case SCHOOL_PROPERTY_TYPE.EMAIL:
            dataType = 'email';
            break;
        default:
            break;
    }

    // --- Override componentType theo ps_code ---
    if (item.ps_code === 'hinh_thuc_can_doi_thuc_don') {
        componentType = 'selectBox';
        listSelect = HinhThucCanDoiThucDonList;
        idField = 'id';
        nameField = 'name';
    }

    if (
        item.ps_code === 'dung_cu_chia_chua_dung_thuc_an_2b' ||
        item.ps_code === 'dung_cu_chua_mau_thuc_an_luu_3'
    ) {
        componentType = 'selectBox';
        listSelect = proPackagingCache;
        idField = 'p_id';
        nameField = 'p_name';
    }

    if (item.ps_code === 'hoa_don_nha_cung_cap') {
        componentType = 'selectBox';
        listSelect = invoiceForm;
        idField = 'if_id';
        nameField = 'if_companyname';
    }

    if (item.p_group === SCHOOL_PROPERTY_GROUP.SERVICE) {
        componentType = 'tableBox';
    }

    if (
        item.ps_code === 'ma_nhom_mau_giao_dich_vu' ||
        item.ps_code === 'ma_nhom_nha_tre_dich_vu'
    ) {
        componentType = 'selectBox';
        listSelect = kidGroupList;
        idField = 'kg_id';
        nameField = 'kg_name';
    }

    if (item.ps_code === 'ngay_thu_tien_dich_vu') {
        componentType = 'dayRangeSelect';
        dataType = 'string';
    }

    return { componentType, dataType, colClass, listSelect, idField, nameField };
}
